import {
  emailTemplateSchema,
  type EmailTemplate,
} from "@redotech/redo-marketing-templates-common/email-template";
import {
  SavedEmailTemplateSource,
  savedEmailTemplateSchema,
  type SavedEmailTemplate,
} from "@redotech/redo-marketing-templates-common/saved-email-template";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const createSavedEmailTemplate = {
  name: "createSavedEmailTemplate" as const,
  input: z.object({
    template: emailTemplateSchema as z.ZodType<EmailTemplate>,
    name: z.string(),
    source: createEnum(SavedEmailTemplateSource),
    isGenerating: z.boolean().optional(),
  }),
  output: savedEmailTemplateSchema as z.ZodType<SavedEmailTemplate>,
};
